import { Ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useCompanyProfileStore } from '@/stores/companyProfileStore'
import type { CompanyProfile } from '@/types/company'

export function useCompanyProfile() {
  const store = useCompanyProfileStore()
  const { profile, isLoading, error } = storeToRefs(store)

  const loadProfile = async (): Promise<void> => {
    if (profile.value) {
      store.$patch({ profile: null, error: null })
    }
    await store.fetchProfile()
  }

  const saveDraft = async (form: Partial<CompanyProfile>) => {
    await store.saveDraft(form)
  }

  const discardDraft = async () => {
    await store.discardDraft()
  }

  const publishProfile = async (payload: Partial<CompanyProfile>) => {
    await store.publishProfile(payload)
  }

  // Explicit return type enforces autocompletion in consumers
  return {
    profile,
    isLoading,
    error,
    loadProfile,
    saveDraft,
    discardDraft,
    publishProfile
  } as {
    profile: Ref<CompanyProfile | null>
    isLoading: Ref<boolean>
    error: Ref<string | null>
    loadProfile: () => Promise<void>
    saveDraft: (form: Partial<CompanyProfile>) => Promise<void>
    discardDraft: () => Promise<void>
    publishProfile: (payload: Partial<CompanyProfile>) => Promise<void>
  }
}
